"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEventTimeCorrectionFlowKey = exports.generateEventTimeFlowKey = exports.generateEventDatetime = exports.generateCurrencyEventDateSecond = exports.generateAccountFlowKey = exports.generateCorrectionFlowKey = exports.generateTransactionFlowKey = exports.generateBalanceFlowKey = exports.generateFlowKey = void 0;
const balance_1 = require("./balance");
const correction_1 = require("./correction");
const DATETIME_MOMENT_FORMAT = 'YYYY-MM-DD HH:mm:ss.SSS';
function generateFlowKey(transaction) {
    return transaction.currency + ':' +
        transaction.settleDate + ':' +
        transaction.source + ':' +
        (transaction.externalId || ('NA')) + ':' +
        transaction.flowType + ':' +
        transaction.direction + ':' +
        (transaction.supplementaryRef || 'NA');
}
exports.generateFlowKey = generateFlowKey;
function generateBalanceFlowKey(balance) {
    if (balance.type === balance_1.BALANCE_TYPES.ACCOUNT) {
        return balance.currency + ':' +
            balance.type + ':' +
            balance.account + ':' +
            balance.balanceDate;
    }
    else if (balance.type === balance_1.BALANCE_TYPES.SECURITY) {
        return balance.identifier + ':' +
            balance.type + ':' +
            balance.balanceDate;
    }
    return 'UNKNOWN_TYPE:' + balance.type;
}
exports.generateBalanceFlowKey = generateBalanceFlowKey;
function generateTransactionFlowKey(correction) {
    return correction.txnCurrency + ':' +
        correction.txnSettleDate + ':' +
        correction.txnSource + ':' +
        (correction.txnExternalId || ('NA')) + ':' +
        correction.txnFlowType + ':' +
        correction.txnDirection + ':' +
        (correction.txnSupplementaryRef || 'NA');
}
exports.generateTransactionFlowKey = generateTransactionFlowKey;
function generateCorrectionFlowKey(correction) {
    if (correction.type === correction_1.CORRECTION_TYPES.BALANCE_CORRECTION) {
        return correction.type + ':' +
            correction.currency + ':' +
            correction.settleDate + ':' +
            correction.account;
    }
    else if (correction.type === correction_1.CORRECTION_TYPES.MANUAL_CORRECTION) {
        return correction.type + ':' +
            correction.currency + ':' +
            correction.settleDate + ':' +
            correction.direction + ':' +
            correction.desk + ':' +
            correction.account;
    }
    else if (correction.type === correction_1.CORRECTION_TYPES.MANUAL_MATCHING_ACCEPT) {
        return correction.type + ':' +
            correction.txnFlowKey;
    }
    else if (correction.type === correction_1.CORRECTION_TYPES.MANUAL_MATCHING_ACCEPT_REVERSAL) {
        return correction.type + ':' +
            correction.txnFlowKey;
    }
    else if (correction.type === correction_1.CORRECTION_TYPES.PASS_THROUGH_ACCEPTANCE) {
        return correction.type + ':' +
            correction.txnFlowKey;
    }
    else if (correction.type === correction_1.CORRECTION_TYPES.PROJECTION_UPDATE) {
        return correction.type + ':' +
            correction.currency + ':' +
            correction.settleDate + ':' +
            correction.direction + ':' +
            correction.desk + ':' +
            correction.projectionUpdateClientGroup + ':' +
            correction.projectionUpdateProductType;
    }
    else if (correction.type === correction_1.CORRECTION_TYPES.TOLERANCE_CORRECTION) {
        return correction.type + ':' +
            correction.currency + ':' +
            correction.settleDate + ':' +
            correction.direction + ':' +
            correction.desk;
    }
    else if (correction.type === correction_1.CORRECTION_TYPES.UNSETTLED_ROLLOVER) {
        return correction.type + ':' +
            correction.txnFlowKey;
    }
    return 'UNKNOWN_TYPE:' + correction.type;
}
exports.generateCorrectionFlowKey = generateCorrectionFlowKey;
function generateAccountFlowKey(transaction) {
    return transaction.currency + ':' +
        transaction.settleDate + ':' +
        (transaction.externalId || ('NA')) + ':' +
        transaction.flowType + ':' +
        transaction.direction + ':' +
        (transaction.supplementaryRef || 'NA');
}
exports.generateAccountFlowKey = generateAccountFlowKey;
function generateCurrencyEventDateSecond(currency, eventDatetime) {
    return currency + eventDatetime.utc().format("YYYYMMDDss");
}
exports.generateCurrencyEventDateSecond = generateCurrencyEventDateSecond;
function generateEventDatetime(eventDatetime) {
    return eventDatetime.utc().format(DATETIME_MOMENT_FORMAT);
}
exports.generateEventDatetime = generateEventDatetime;
function generateEventTimeFlowKey(eventDatetime, flowKey, transaction) {
    if (!flowKey) {
        if (transaction) {
            flowKey = generateFlowKey(transaction);
        }
    }
    return eventDatetime.utc().format('YYYYMMDDHHmmssSSS') + flowKey;
}
exports.generateEventTimeFlowKey = generateEventTimeFlowKey;
function generateEventTimeCorrectionFlowKey(correction, eventDatetime) {
    return eventDatetime.utc().format('YYYYMMDDHHmmssSSS') + generateCorrectionFlowKey(correction);
}
exports.generateEventTimeCorrectionFlowKey = generateEventTimeCorrectionFlowKey;
//# sourceMappingURL=flow-key.js.map